<template>
  <div class="text-[24px]">
    <div class="hidden sm:block">
      <stage-group-list
        class="uppercase"
        title="Category"
        :header="true"
        price="Price"
        tickets="Tickets"
      />
    </div>
    <template v-for="(category, index) in seatCategories" :key="index">
      <stage-group-list
        :title="category.name"
        :price="category.price"
        :tickets="category.tickets"
      >
        <template #icon>
          <span
            class="material-icons text-[45px] mr-6"
            :style="`color:${category.color}`"
          >
            chair
          </span>
        </template>
      </stage-group-list>
    </template>
  </div>
</template>
<script>
import { computed, reactive, toRefs } from "@vue/runtime-core";
import StageGroupList from "./StageGroupList.vue";
import { useStore } from "vuex";
export default {
  components: { StageGroupList },
  name: "SeatSummary",
  setup() {
    const store = useStore();
    const state = reactive({
      seatCategories: computed(() => store.getters["show/seatCategories"]),
    });

    return {
      ...toRefs(state),
    };
  },
};
</script>
